import { CommonModule } from '@angular/common';
import { Component, input, output, TemplateRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  public modalTitle = input<string>();
  public mainContentTemplate = input<TemplateRef<any>>();
  public secondaryActionTemplate = input<TemplateRef<any>>();
  public primaryActionTemplate = input<TemplateRef<any>>();
  public scrollableBody = input(false);

  public closed = output<void>();
}
